import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import uiData from "./data.json";

const ItemMaster = () => {
  const [itemName, setItemName] = useState("");
  const [category, setCategory] = useState(uiData.form.fields.category[0]);
  const [tableData, setTableData] = useState([]);
  const [srNo, setSrNo] = useState(1);
  const navigate = useNavigate();

  const handleSave = () => {
    if (itemName.trim() === "") return;

    const newRow = { srNo, itemName, category };
    setTableData([...tableData, newRow]);
    setSrNo(srNo + 1);
    setItemName("");
    setCategory(uiData.form.fields.category[0]);
  };

  const handleExit = () => {
    navigate("/dashboard");
  };

  return (
    <div className="flex flex-col min-h-screen text-sm font-sans bg-[#f5f1d7]">
      <div className="flex flex-col sm:flex-row justify-between items-center border-b border-black bg-[#d8d2b0] px-2 py-1 text-xs">
        <span>{uiData.header.softwareName}</span>
        <span>{uiData.header.contact}</span>
      </div>
      <div className="text-center font-bold py-1 border-b border-black">
        {uiData.header.title}
      </div>

      <div className="flex flex-col lg:flex-row flex-1 overflow-hidden">
        <div className="flex-1 border-r border-black p-3 overflow-auto">
          <div className="mb-2">
            <span className="font-semibold">Item Code:</span> {uiData.form.itemCode}
          </div>

          <div className="flex flex-col md:flex-row justify-between">
            <div className="mb-2 flex flex-col sm:flex-row items-start sm:items-center gap-2">
              <label className="w-40">{uiData.form.fields.itemName}</label>
              <input
                value={itemName}
                onChange={(e) => setItemName(e.target.value)}
                className="border border-black flex-1 bg-gray-200 px-2 py-1"
              />
            </div>

            <div className="flex flex-col gap-1 mt-2 md:mt-4">
              {uiData.sidebar.PrintChangeButtons.map((btn, idx) => (
                <button
                  key={idx}
                  className="border border-black bg-[#d8d2b0] px-2 py-1 text-xs"
                >
                  {btn}
                </button>
              ))}
            </div>
          </div>

          <div className="mb-2 flex flex-wrap items-center gap-2">
            <label className="w-40">{uiData.form.fields.source.label}</label>
            {uiData.form.fields.source.options.map((opt, idx) => (
              <label key={idx} className="flex items-center gap-1">
                <input type="radio" name="source" /> {opt}
              </label>
            ))}
          </div>

          <div className="mb-2 flex items-center flex-wrap gap-2">
            <label className="w-40">{uiData.form.fields.commission}</label>
            <input className="border border-black w-20 px-1" defaultValue="0" />
          </div>

          <div className="mb-2 flex flex-wrap items-center gap-2">
            <label className="w-40">{uiData.form.fields.userCharge}</label>
            <div className="flex flex-wrap gap-2">
              <button className="px-3 border border-black bg-green-200">{uiData.form.buttons.yes}</button>
              <button className="px-3 border border-black bg-red-200">{uiData.form.buttons.no}</button>
              <button className="px-3 border border-black bg-yellow-100">{uiData.form.buttons.vendor1}</button>
              <button className="px-3 border border-black bg-pink-100">{uiData.form.buttons.vendor2}</button>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
            <div className="mb-2 flex items-start flex-col sm:flex-row gap-2">
              <label className="w-40">Item Category:</label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="border border-black w-40 px-1"
              >
                {uiData.form.fields.category.map((num, idx) => (
                  <option key={idx} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-col gap-1 mt-2 md:mt-4">
              {uiData.sidebar.bulkButtons.map((btn, idx) => (
                <button key={idx} className="border border-black bg-[#d8d2b0] px-2 py-1 text-xs">
                  {btn}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full lg:w-60 border-t lg:border-t-0 lg:border-l border-black flex lg:flex-col flex-row justify-between p-2 gap-2 overflow-auto">
          <div className="flex w-full flex-wrap lg:flex-col gap-2">
            {uiData.sidebar.buttons.map((btn, idx) => {
              const isSave = btn === "Save";
              const isExit = btn === "Exit";

              return (
                <button
                  key={idx}
                  onClick={isExit ? handleExit : isSave ? handleSave : undefined}
                  disabled={isSave && itemName.trim() === ""}
                  className={`border md:w-full border-black px-2 py-2 text-left text-xs ${isSave
                      ? itemName.trim() === ""
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-[#d8d2b0] hover:bg-[#c8c09e]"
                      : isExit
                        ? "bg-[#d8d2b0] hover:bg-[#c8c09e]"
                        : "bg-[#d8d2b0]"
                    }`}
                >
                  {btn}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row border-t border-black flex-1 overflow-auto">
        <div className="flex-1 p-2 border-r border-black overflow-auto">
          <table className="w-full border border-black text-left text-xs table-auto">
            <thead>
              <tr className="bg-[#d8d2b0]">
                {uiData.table.columns.map((col, idx) => (
                  <th key={idx} className="border border-black px-2 py-1">
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.length === 0 ? (
                <tr>
                  <td colSpan={uiData.table.columns.length} className="text-center border border-black py-2">
                    No data added yet
                  </td>
                </tr>
              ) : (
                tableData.map((row, idx) => (
                  <tr key={idx}>
                    <td className="border border-black px-2 py-1">{row.srNo}</td>
                    <td className="border border-black px-2 py-1">{row.itemName}</td>
                    <td className="border border-black px-2 py-1">{row.category}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="w-full lg:w-64 p-2 text-xs bg-[#f5f1d7] flex flex-col gap-2">
          <div className="flex flex-col sm:flex-row justify-between gap-2">
            <div className="flex flex-col gap-2 font-semibold">
              <div>{uiData.searchSection.searchByName}</div>
              <div>{uiData.searchSection.searchByCategory}</div>
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex flex-wrap gap-2">
                {uiData.searchSection.options.map((opt, idx) => (
                  <label key={idx} className="flex items-center gap-1">
                    <input type="radio" name="filter" /> {opt}
                  </label>
                ))}
              </div>
              <label className="flex items-center gap-1">
                <input type="checkbox" /> {uiData.searchSection.showDeletedItems}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemMaster;